import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

const LeaveWarningsCard = ({ leaveWarnings }) => {
  if (!leaveWarnings || leaveWarnings.length === 0) return null;
  
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="flex items-center gap-2">
          <AlertTriangle className="h-5 w-5 text-orange-600" />
          Leave Balance Warnings
        </CardTitle>
        <Badge variant="outline" className="bg-orange-50 text-orange-700">
          {leaveWarnings.length} employees
        </Badge>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {leaveWarnings.map((warning) => (
            <div 
              key={warning.employee_id} 
              className={`flex items-center justify-between p-3 rounded-lg border ${
                warning.warning_level === 'exhausted' 
                  ? 'bg-red-50 border-red-300' 
                  : warning.warning_level === 'critical'
                  ? 'bg-orange-50 border-orange-300'
                  : 'bg-yellow-50 border-yellow-300'
              }`}
              data-testid={`leave-warning-${warning.employee_code}`}
            >
              <div>
                <p className="font-medium text-sm">{warning.employee_name}</p>
                <p className="text-xs text-gray-600">{warning.employee_code} - {warning.department}</p>
              </div>
              <div className="text-right">
                <Badge 
                  variant="outline" 
                  className={
                    warning.warning_level === 'exhausted' 
                      ? 'bg-red-100 text-red-700' 
                      : warning.warning_level === 'critical'
                      ? 'bg-orange-100 text-orange-700'
                      : 'bg-yellow-100 text-yellow-700'
                  }
                >
                  {warning.warning_level === 'exhausted' ? 'No Leave Left' : 
                   warning.warning_level === 'critical' ? 'Critical' : 'Low'}
                </Badge>
                <p className="text-xs text-gray-500 mt-1">
                  {warning.annual_balance} / {warning.annual_total} days remaining
                </p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default LeaveWarningsCard;
